export enum NuclideManagementViewModalType {
	GENERATOR_CREATE = 'GENERATOR_CREATE',
	CYCLOTRON_PRODUCT_CREATE = 'CYCLOTRON_PRODUCT_CREATE'
}